<template>
  <div v-if="isOpen" class="modal-overlay">
    <div class="modal-content">
      <p>{{ message }}</p>
      <div>
        <button @click="handleCancel">Annuler</button>
        <button @click="handleConfirm">Confirmer</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useConfirm } from '../composables/useConfirm';

const {
  isOpen,
  message,
  handleCancel,
  handleConfirm,
} = useConfirm();
</script>